<template >
  <div id="page-forms">
    <v-tabs
      color="transparent"
      icons-and-text
    >
      <v-tabs-slider color="primary"></v-tabs-slider>
      <v-tab
        key="#tab-1"
        color="white"
      >General
        <v-icon>developer_board</v-icon>
      </v-tab>
      <v-tab
        key="#tab-2"
        color="white"
      >
        Allowable Scrap
        <v-icon>apps</v-icon>
      </v-tab>

      <v-tabs-items>
        <v-tab-item key="#tab-1">
          <v-card flat>
            <bom-form ref="bomform"></bom-form>
          </v-card>
        </v-tab-item>
        <v-tab-item key="#tab-2">
          <v-card flat>
            <scrap-allowable ref="allowableform"></scrap-allowable>
          </v-card>
        </v-tab-item>

      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
import BomForm from '@/pages/scrap/BlisterStripWeight';
import ScrapAllowable from '@/pages/scrap/BlisterScrapAllowableList';

export default {
  components: {
    BomForm,
    ScrapAllowable,

  },
  data () {
    return {
      items: [
        { title: 'Clear Items' },
        { title: 'Post' },
        { title: 'Delete' },
        { title: 'Print' }
      ],    };
  },
  computed: {
    posts () {
      return getPost();
    }
  },
  methods: {
    handleClick: e => {
      console.log(e);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/scrap/BlisterBOM.vue